import { useQuery } from '@tanstack/react-query';
import { ApiPropertyRepository } from '../../infrastructure/api/ApiPropertyRepository';

const repository = new ApiPropertyRepository();

export default function useGetPropertyDetails(propertyId: string): {
  propertyDetails: any | null;
  errorPropertyDetails: Error | null;
  isLoadingPropertyDetails: boolean;
} {
  const getQuery = useQuery({
    queryKey: [ 'get_property_detail', propertyId ],
    queryFn: () => repository.findById(propertyId),
    enabled: !!propertyId,
    meta: {
      queryName: 'get_property_detail',
      queryKeyHash: 'get_property_detail'
    },
  });

  if (getQuery.isError) {
    //   throw new Error(getQuery.error.message);
    console.error('There was an error in getPropertyDetails ', getQuery.error.message);
  }

  return {
    propertyDetails: getQuery.data || null, // Access response.data
    errorPropertyDetails: getQuery.isError ? getQuery.error : null, // Access error
    isLoadingPropertyDetails: getQuery.isLoading,
  };
}
